// @flow
export default {
  accountOperation: { model: null },
}
